var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"camera--wrapper"},[_c('js-camera',{ref:"js-camera",attrs:{"audio":"false","facing":"back"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }